function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M0 0h15v25H0z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  "data-svg-class": "RoomButton-stroke",
  d: "M.5.5h14v24H.5z"
}), /*#__PURE__*/React.createElement("circle", {
  "data-svg-class": "RoomButton-fill",
  cx: 7.5,
  cy: 5.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  "data-svg-class": "RoomButton-stroke",
  cx: 7.5,
  cy: 5.5,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  "data-svg-class": "RoomButton-fill",
  cx: 7.5,
  cy: 19.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  "data-svg-class": "RoomButton-stroke",
  cx: 7.5,
  cy: 19.5,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M6 11h3v5H6z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  "data-svg-class": "RoomButton-stroke",
  d: "M6.5 11.5h2v4h-2z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M6 9h3v3H6z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  "data-svg-class": "RoomButton-stroke",
  d: "M6.5 9.5h2v2h-2z"
})));

function SvgRoomElectricitySwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomElectricitySwitch);
export default __webpack_public_path__ + "static/media/RoomElectricitySwitch.d55f7324.svg";
export { ForwardRef as ReactComponent };